import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PoscurriencesService {

  constructor(private http: HttpClient) { }

  url = environment.serverAPI5 + "/api"

  newcurrencies(currencies: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/currencies`, currencies)
	}

  currencies(Page: number, size: number, sort): Observable<Object> {
		return this.http.get(`${this.url}/currencies?page=${Page}&size=${size}&sort=${sort}`);
	}

  currenciesSearch(query:any, Page: any, size: any, sort: any): Observable<Object> {

		return this.http.get(`${this.url}/currencies/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	deleteByCurrenciesId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/currencies/${id}`);
	}
	downloadCurrenciesTemplate(): Observable<any> {
		return this.http.get(`${this.url}/currencies/template/download`, {responseType: 'arraybuffer',observe: 'response' });
	  }
	  downloadCurrenciesReport(Page: number, size: number, sort,selectionCurriences): Observable<any> {
		return this.http.post(`${this.url}/currencies/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionCurriences, { 
		  responseType: 'arraybuffer',
		  observe: 'response'
		});
	  }
}
